const frequencyKeyValues = {
  '1 weekly': 'Every week',
  '2 weekly': 'Every 2 weeks',
  '3 weekly': 'Every 3 weeks',
  '4 weekly': 'Every 4 weeks',
  '1 monthly': 'Every month',
  '2 monthly': 'Every 2 months',
  '3 monthly': 'Every 3 months',
  '6 monthly': 'Every 6 months',
  '12 monthly': 'Every year',
};
const frequencyValuesKey = {
  'Every week': '1 weekly',
  'Every 2 weeks': '2 weekly',
  'Every 3 weeks': '3 weekly',
  'Every 4 weeks': '4 weekly',
  'Every month': '1 monthly',
  'Every 2 months': '2 monthly',
  'Every 3 months': '3 monthly',
  'Every 6 months': '6 monthly',
  'Every year': '12 monthly',
};
const FrequencyUtils = {
  getFrequencyKey(value) {
    if (frequencyValuesKey.hasOwnProperty(value)) {
      return frequencyValuesKey[value];
    } else {
      return null;
    }
  },
  getFrequencyValue(key) {
    if (frequencyKeyValues.hasOwnProperty(key)) {
      return frequencyKeyValues[key];
    } else {
      return null;
    }
  },
};

export default FrequencyUtils;
